import { useState } from "react";

export const useActiveJournal = () => {
  const [activeJournal, setActiveJournalInternal] = useState(() => {
    const storedJournal = localStorage.getItem("activeJournal");
    try {
      return storedJournal ? JSON.parse(storedJournal) : null;
    } catch (error) {
      console.error('Error parsing activeJournal from localStorage:', error);
      return null;
    }
  });

  const setActiveJournal = (journal) => {
    try {
      if (journal) {
        const journalString = JSON.stringify(journal);
        localStorage.setItem("activeJournal", journalString);
        setActiveJournalInternal(journal);
      } else {
        localStorage.removeItem("activeJournal");
        setActiveJournalInternal(null);
      }
    } catch (error) {
      console.error('Error setting active journal:', error);
    }
  };

  const clearActiveJournal = () => {
    localStorage.removeItem("activeJournal");
    setActiveJournalInternal(null);
  };

  return [activeJournal, setActiveJournal, clearActiveJournal];
};